/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React from "react";
import "./renderSelectML.css";
import { AuthConsumer } from "../../AuthContext";

export function renderSelectML(buttonOverrideStyle, buttonOverrideTextStyle, supportedLanguages = ['en', 'zh', 'cn']) {
  function renderSelector(i18n) {
    function handleChange(e) {
      const change = e.target.value;
      i18n.changeLanguage(change);
    }

    // Language labels mapping
    const languageLabels = {
      'zh': '繁體中文',
      'cn': '简体中文',
      'en': 'English'
    };

    return (
      <select
        className="renderSelectML-selectText"
        onChange={handleChange}
        value={i18n.language}
      >
        {supportedLanguages.map((langCode) => (
          <option key={langCode} value={langCode}>
            {languageLabels[langCode] || langCode}
          </option>
        ))}
      </select>
    );
  }

  return <AuthConsumer>{({ i18n }) => renderSelector(i18n)}</AuthConsumer>;
}
